import { confirmSubscription } from '@/api/payment';
import Vue from 'vue';
import Component from 'vue-class-component';
@Component({
    name: 'PaymentConfirmed'
})
export default class PaymentConfirmed extends Vue {
    paramsError = false;
    confirmationError = false;
    errorMessage = '';

    async created() {
        const storeUrl = this.$route.params.storeUrl;
        const chargeId = this.$route.query.charge_id;
        const timestamp = this.$route.query.timestamp;
        const nonce = this.$route.query.nonce;
        const key = this.$route.query.key;

        if (
            storeUrl &&
            chargeId &&
            timestamp &&
            nonce &&
            key &&
            typeof chargeId === 'string' &&
            typeof timestamp === 'string' &&
            typeof nonce === 'string' &&
            typeof key === 'string'
        ) {
            try {
                const response = await confirmSubscription(storeUrl, chargeId, timestamp, nonce, key);

                // If the subscription is confirmed, redirect the user to the app
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else {
                    this.confirmationError = true;
                    this.errorMessage = 'Redirection failed';
                }
            } catch (error) {
                if (error?.response?.status !== 400 && error?.response?.status !== 401) {
                    window.captureException(error);
                }
                this.confirmationError = true;
                this.errorMessage = error.response.data?.message;
            }
        } else {
            this.paramsError = true;
        }
    }
}
